/**
 * TASK-084 — react-query mutation hook for the universal soft-delete endpoint.
 * On 409 BLOCKING_REFERENCES_EXIST the error surface is a
 * {@link BlockingRefsError}; callers should branch on `isBlockingRefsError(error)`
 * to render the refs-list dialog with the redirect alternative.
 */
import { useMutation, useQueryClient } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { deleteRecord } from '../api/recordService';
import { isBlockingRefsError } from '../utils/parseBlockingRefsError';
export var useDeleteRecord = function (recordId, options) {
    if (options === void 0) { options = {}; }
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (comment) { return deleteRecord(ky, recordId, comment); }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(['record', recordId]);
            queryClient.invalidateQueries(['records']);
            queryClient.invalidateQueries(['review-queue']);
            queryClient.invalidateQueries(['vocabularies']);
            (_a = options.onSuccess) === null || _a === void 0 ? void 0 : _a.call(options);
        },
        onError: function (error) {
            var _a, _b;
            // `isBlockingRefsError`, NOT `instanceof` — see its javadoc. The ES5 build breaks the
            // prototype chain of every `extends Error`, so `instanceof BlockingRefsError` is false
            // in the browser and true in jest. This line branched on it and sent real 409s to
            // `options.onError`, which no caller passes: the blocked panel never opened, for any
            // record type.
            if (isBlockingRefsError(error)) {
                (_a = options.onBlocked) === null || _a === void 0 ? void 0 : _a.call(options, error);
            }
            else {
                (_b = options.onError) === null || _b === void 0 ? void 0 : _b.call(options, error);
            }
        },
    });
};
